import { fetch } from "../../utils/dataAccess";

export function error(error) {
    return {type: "CATEGORY_LIST_ERROR", error};
}

export function loading(loading) {
    return {type: "CATEGORY_LIST_LOADING", loading};
}

export function success(retrieved) {
    return {type: "CATEGORY_LIST_SUCCESS", retrieved};
}

export function categoryList(params = "pagination=false&draft=false") {
    return dispatch => {
        dispatch(loading(true));

        fetch(`/categories?${params}`).then(response => {
            response.json().then(retrieved => {
                dispatch(loading(false));
                dispatch(success(retrieved["hydra:member"]));
            })
        }).catch(error => {
            // canceled
        });
    };
}

export function categoryExist(category, categoryTree) {
    if (!category) {
        return false;
    }

    return !!categoryTree.find(categoryIt => category.id === categoryIt.id)
}

export function reset() {
    return dispatch => {
        dispatch({type: "CATEGORY_LIST_RESET"});
        dispatch(loading(false));
        dispatch(error(null));
        dispatch(success(null))
    };
}
